import SiteLayout from "@/components/feature/SiteLayout";
import Seo, { JsonLd } from "@/components/feature/Seo";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ContactForm from "./components/ContactForm";

const channels = [
  {
    icon: "ri-mail-line",
    title: "内容反馈与合作",
    value: "contact@dujiaguacchi.example",
    desc: "内容更正、线索提供和商务合作都发这个邮箱，我们会在一个工作日内回复。",
  },
  {
    icon: "ri-time-line",
    title: "回复时间",
    value: "工作日 09:00 - 18:00",
    desc: "周末与节假日的留言会顺延到下一个工作日集中处理，热点相关线索会优先查看。",
  },
  {
    icon: "ri-chat-smile-2-line",
    title: "快讯更新时段",
    value: "每日 07:00 - 23:00",
    desc: "早间、午间、晚间各有一轮集中采编，突发动态会以快讯形式即时补充。",
  },
];

export default function ContactPage() {
  const contactSchema = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: "联系我们 - 独家吃瓜",
    description: "通过留言表单联系独家吃瓜，反馈内容问题、提供爆料线索或洽谈合作。",
    inLanguage: "zh-CN",
    url: "https://mvlock.cn/contact",
    mainEntity: {
      "@type": "Organization",
      name: "独家吃瓜",
      email: "contact@dujiaguacchi.example",
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer support",
        email: "contact@dujiaguacchi.example",
        availableLanguage: ["zh-CN"],
      },
    },
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://mvlock.cn/" },
      { "@type": "ListItem", position: 2, name: "联系我们", item: "https://mvlock.cn/contact" },
    ],
  };

  return (
    <>
      <Seo
        title="联系我们 - 独家吃瓜留言与爆料投稿"
        description="联系独家吃瓜：通过留言表单反馈内容问题、提供娱乐爆料线索或洽谈合作，工作日 09:00 - 18:00 回复。"
        keywords="联系独家吃瓜,爆料投稿,内容反馈,合作咨询"
        path="/contact"
      />
      <JsonLd data={contactSchema} />
      <JsonLd data={breadcrumbSchema} />
      <SiteLayout>
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-8 md:py-10">
          <Breadcrumb items={[{ label: "联系我们" }]} />

          <header className="mb-8">
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 tracking-tight">
              联系我们
            </h1>
            <p className="mt-3 text-sm text-foreground-600 font-label max-w-2xl">
              想反馈一条内容、提供一条线索，或者聊聊合作，都可以直接在这里留言。留下邮箱，我们会尽快回复。
            </p>
          </header>

          <div className="grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-8 lg:gap-10">
            <ContactForm />

            <aside className="space-y-4">
              {channels.map((item, index) => (
                <div
                  key={item.title}
                  className={`rounded-lg p-5 border ${
                    index === 1
                      ? "bg-accent-50 border-accent-200"
                      : "bg-background-100 border-background-200"
                  }`}
                >
                  <div className="flex items-center gap-3 mb-3">
                    <span
                      className={`w-10 h-10 rounded-lg flex items-center justify-center text-lg ${
                        index === 1
                          ? "bg-accent-500 text-foreground-950"
                          : "bg-secondary-100 text-secondary-700"
                      }`}
                    >
                      <i className={item.icon}></i>
                    </span>
                    <h2 className="font-heading text-base font-semibold text-foreground-950">
                      {item.title}
                    </h2>
                  </div>
                  <p className="text-sm text-foreground-900 font-medium font-label">{item.value}</p>
                  <p className="mt-2 text-xs text-foreground-600 leading-relaxed font-label">
                    {item.desc}
                  </p>
                </div>
              ))}

              <div className="rounded-lg bg-secondary-950 p-5">
                <h2 className="font-heading text-base font-bold text-background-50 mb-2">
                  提供爆料线索时
                </h2>
                <p className="text-xs text-background-300 leading-relaxed font-label">
                  如果能一并说明时间、地点和可公开的来源类型，我们会更快核实。对于尚未确认的信息，我们会按内容原则标注说明，不做确定性表述。
                </p>
              </div>
            </aside>
          </div>
        </div>
      </SiteLayout>
    </>
  );
}